import React, { useEffect, useState, useCallback } from 'react'
import { superAxiosRequest } from 'axiosApi'
import asideModalStore from 'Stores/asideModalStore'
import swal from 'sweetalert'
import st from './Companies.module.scss'
import PageHeader from 'components/UI/PageHeader/PageHeader'
import { HeaderAddButton } from 'components/UI/SuperButton/SuperButton'
import Pagination from 'components/UI/Pagination/Pagination'
import Loader from 'components/UI/Loader/Loader'
import RowCompany from './RowCompany/RowCompany'
import CompaniesModal from './CompaniesModal/CompaniesModal'
import AsideFilterStore from 'components/UI/AsideFilter/asideFilterStore'
import useLocalStorageFilter from 'helpers/useLocalStorageFilter'
import SearchBooks from '../../../Modules/Ebook/Books/components/SearchBooks/SearchBooks'
import FilterTextValues from 'components/UI/AsideFilter/FilterTextValues'
import AsideFilter from 'components/UI/AsideFilter/AsideFilter'
import useLocalization from 'hooks/useLocalization'
import { observer } from 'mobx-react'
import { useHistory } from 'react-router-dom'
import { translate as loc } from 'Localisation/Localisation'
import { dict } from 'Localisation'

const initPagination = { page: 1, limit: 10 }
const config = [
  {
    nameState: 'search',
    placeholder: loc(dict.main_page.company),
    type: 'input',
    label: loc(dict.main_page.company),
  },
]
const sharedInitialValues = {
  fixed_price: 0,
  sum1: 0,
  sum2: 0,
  amount_lesson: 0,
  email: false,
  wazzap: false,
  mark_type: 1,
}

const Companies = () => {
  const [companies, setCompanies] = useState(null)
  const [loading, setLoading] = useState(false)
  const [pagination, setPagination] = useState(initPagination)

  const {
    isOpenFilter,
    closeFilter,
    setTextValues,
    changeTextValue,
    filterTextValues,
  } = AsideFilterStore
  const [filter, updateFilter] = useLocalStorageFilter({})
  const history = useHistory()

  const { translate } = useLocalization({
    section: 'groups',
    subsection: 'all_groups',
    dict: {
      filter: 'Filter',
      search: 'Search',
      start_date: 'Start Date',
      end_date: 'End Date',
      reset_all: 'Reset All',
      apply: 'Apply',
      edit: 'Edit',
      copy: 'Copy',
      delete: 'Delete',
      save: 'Save',
    },
  })

  const fetchCompanies = useCallback(() => {
    setLoading(true)
    superAxiosRequest({
      method: 'get',
      link: 'db/companies',
      params: {
        ...filter,
        offset: (pagination.page - 1) * pagination.limit,
        limit: pagination.limit,
      },
    }).then(({ data }) => {
      setCompanies(data)
      setLoading(false)
    })
  }, [pagination])

  useEffect(() => {
    fetchCompanies()
  }, [fetchCompanies, filter])

  const normalizeCompanyData = (data) => {
    const { company, currency, ...rest } = data
    return {
      ...rest,
      ...(company && { company: company.id }),
      ...(currency && {
        currency: typeof currency === 'object' ? currency.id : currency,
      }),
    }
  }

  const sharedSubmitTransform = (data) => {
    const normalized = normalizeCompanyData(data)

    const notification_student = {}
    if (+normalized.fixed_price)
      notification_student.fixed_price = +normalized.fixed_price
    if (+normalized.sum1) notification_student.sum1 = +normalized.sum1
    if (+normalized.sum2) notification_student.sum2 = +normalized.sum2
    if (+normalized.amount_lesson)
      notification_student.amount_lesson = +normalized.amount_lesson
    if (normalized.email) notification_student.email = true
    if (normalized.wazzap) notification_student.wazzap = true

    const hasNotificationFields = Object.keys(notification_student).length > 0

    const cleaned = {
      name: normalized.name,
      comment: normalized.comment,
      currency: normalized.currency,
      mark_type: +normalized.mark_type || 1,
      ...(normalized.active_cashback && {
        active_cashback: true,
        percent: +normalized.percent || 0,
        block_period: +normalized.block_period || 0,
      }),
      ...(hasNotificationFields && { notification_student }),
    }

    return cleaned
  }

  const addCompany = () => {
    asideModalStore.activity(
      {
        isResponsive: true,
        modalBodyComponent: () => <CompaniesModal />,
        button: 'Save',
        link: 'db/companies',
        title: 'Добавить компанию',
        onBeforeSubmit: sharedSubmitTransform,
        onSubmitSuccess: fetchCompanies,
        valid: {
          name: 'required',
          currency: 'required',
          comment: 'required',
        },
      },
      { ...sharedInitialValues },
    )
  }

  const editCompany = (data) => {
    const notification = data.notification_student || {}

    asideModalStore.activity(
      {
        isResponsive: true,
        is_put: true,
        modalBodyComponent: () => <CompaniesModal />,
        button: 'Save',
        link: `db/companies/${data.id}`,
        title: 'Редактировать компанию',
        onBeforeSubmit: sharedSubmitTransform,
        onSubmitSuccess: (updated) => {
          setCompanies((prev) => ({
            ...prev,
            result: prev.result.map((item) =>
              item.id === updated.id ? { ...item, ...updated } : item,
            ),
          }))
        },
        valid: {
          name: 'required',
          currency: 'required',
          comment: 'required',
        },
      },
      {
        ...data,
        ...(data.currency && { currency: data.currency.id }),
        fixed_price: data.fixed_price || 0,
        sum1: notification.sum1 || 0,
        sum2: notification.sum2 || 0,
        amount_lesson: notification.amount_lesson || 0,
        email: notification.email || false,
        wazzap: notification.wazzap || false,
        mark_type: data.mark_type ?? 1,
      },
    )
  }

  const deleteCompany = (data) => {
    swal({
      title: 'Are you sure',
      text: 'Are you sure you want to delete the company?',
      icon: 'warning',
      buttons: ['No', 'Yes'],
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        superAxiosRequest({
          method: 'delete',
          link: `db/companies/${data.id}`,
        }).then(() => {
          setCompanies((prev) => ({
            ...prev,
            result: prev.result.filter((el) => el.id !== data.id),
          }))
        })
      }
    })
  }

  const action = (action, _, item) => {
    if (action === 'edit') return editCompany(item)
    if (action === 'delete') return deleteCompany(item)
  }

  useEffect(() => {
    const unlisten = history.listen((location) => {
      if (location.pathname !== `c/company/companies`) {
        updateFilter({})
      }
    })
    return () => {
      unlisten()
    }
  }, [history, updateFilter])

  useEffect(() => {
    return AsideFilterStore.unmountFilter
  }, [])

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === 'filter') {
        const storedFilter = localStorage.getItem('filter')
        updateFilter(storedFilter ? JSON.parse(storedFilter) : {})
      }
    }

    window.addEventListener('storage', handleStorageChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
    }
  }, [updateFilter])

  return (
    <div>
      <div className={st.header}>
        <PageHeader title='Компании'>
          <HeaderAddButton title='Добавить компанию' onClick={addCompany} />
        </PageHeader>
      </div>

      <div style={{ padding: '0px 20px' }} className={st.filter}>
        <SearchBooks
          onSearch={(text) => {
            updateFilter({ ...filter, search: text })
            changeTextValue('search', {
              key: 'search',
              label: `${translate?.search}...`,
              value: text,
            })
          }}
          onClear={() => {
            const { name: text, ...obj } = filter
            updateFilter(obj)
            setTextValues(
              filterTextValues.filter((field) => field.key !== 'search'),
            )
          }}
          value={filter?.search || ''}
          placeholder={`${translate?.search}...`}
          translate={translate}
        />
        {isOpenFilter && (
          <AsideFilter
            getFilterParams={(e) => {
              updateFilter(e)
            }}
            config={config}
            filterValue={filter}
            onDropFilter={() => {
              updateFilter({})
              closeFilter()
            }}
            translate={translate}
          />
        )}
        {!!filterTextValues.length && (
          <div style={{ paddingTop: '10px' }}>
            <FilterTextValues
              onDelete={(key) => {
                const { [key]: _, ...obj } = filter
                updateFilter(obj)
              }}
            />
          </div>
        )}
      </div>

      {loading ? (
        <Loader />
      ) : (
        <div className={st.conteinerClient}>
          <div className={st.quantityClients}>
            Записей: {companies?._meta?.count_items || 0}
          </div>
          <div>
            {companies?.result?.length > 0 ? (
              companies.result.map((company, index) => (
                <RowCompany
                  key={company.id}
                  company={company}
                  index={index}
                  action={action}
                />
              ))
            ) : (
              <div className={st.empty}>Нет компаний</div>
            )}
          </div>
        </div>
      )}

      {companies?._meta?.count_items > 10 && (
        <div className={st.pagination}>
          <Pagination
            limit={pagination.limit}
            count={companies._meta.count_items}
            page={pagination.page}
            onChange={(page) => setPagination((prev) => ({ ...prev, page }))}
            onChangePerPage={(limit) => setPagination({ page: 1, limit })}
          />
        </div>
      )}
    </div>
  )
}

export default observer(Companies)
